import type { components } from '@/api/schema'

type Settings = components['schemas']['ClassificationSettingsRead']
export type ClassificationConfig = {
  version: number
  permissions: Required<NonNullable<Settings['permissions']>>
  assessments: Required<NonNullable<Settings['assessments']>>
}
export type ClassificationTargets = components['schemas']['ClassificationTargetsResponse']

export function normalizeConfig(settings: Settings): ClassificationConfig {
  return {
    version: settings.version ?? 0,
    permissions: {
      archive: settings.permissions?.archive ?? false,
      mark_read: settings.permissions?.mark_read ?? false,
      move: settings.permissions?.move ?? false,
      labels: settings.permissions?.labels ?? false,
      categories: settings.permissions?.categories ?? false,
      allowed_move_target_ids: settings.permissions?.allowed_move_target_ids ?? [],
      allowed_label_ids: settings.permissions?.allowed_label_ids ?? [],
      allowed_category_ids: settings.permissions?.allowed_category_ids ?? [],
    },
    assessments: {
      spam: settings.assessments?.spam ?? false,
      phishing: settings.assessments?.phishing ?? false,
      spam_folder_id: settings.assessments?.spam_folder_id ?? null,
      phishing_folder_id: settings.assessments?.phishing_folder_id ?? null,
    },
  }
}
